import { render, staticRenderFns } from "./Action.vue?vue&type=template&id=ff35c1c6&scoped=true"
import script from "./Action.js?vue&type=script&lang=js&external"
export * from "./Action.js?vue&type=script&lang=js&external"
import style0 from "./Action.scss?vue&type=style&index=0&id=ff35c1c6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff35c1c6",
  null
  
)

export default component.exports